export default __webpack_public_path__ + "static/media/joselisaChaves.31b0dc77.jpeg";